import { useState } from "react";
import Header from "../components/Layouts/Header";

function MainLayout({children, isMain}) {
  return(
    <>
      <Header isMain={isMain} />

      <main className="main-content">
        {children}
      </main>
    </>
  );
}

export default MainLayout;